import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {NAVIGATE_EVENT} from './utils';

@customElement('app-link')
export class AppLinkElement extends LitElement {
  @property({type: String})
  href = '';

  static get styles() {
    return css`
      a {
        color: inherit;
        text-decoration: inherit;
      }
    `;
  }

  updated() {
    const shadowRoot = this.shadowRoot;
    if (!shadowRoot) return;
    shadowRoot.querySelectorAll('a').forEach(ele => {
      ele.addEventListener(
        'click',
        e => {
          e.preventDefault();
          this.dispatchEvent(
            new CustomEvent(NAVIGATE_EVENT, {
              detail: this.href,
              bubbles: true,
              composed: true,
            })
          );
        },
        false
      );
    });
  }

  render() {
    return html`<a href="${this.href}"><slot></slot></a>`;
  }
}
